export default defineNuxtRouteMiddleware(async (to) => {
  const { user, fetchUser } = useAuth()

  // Allow invitation pages, MFA setup pages, and the dedicated logout page
  // without auth. `/logout` must run even when the session is already gone
  // (e.g. an IdP-initiated single-logout redirect), so it can't be gated
  // behind the "must have a user" check below.
  if (
    to.path.startsWith('/invitation/') ||
    to.path.startsWith('/account/required/mfa') ||
    to.path === '/logout'
  ) {
    return
  }

  // Try to set the global user if it's not already set
  if (!user.value) {
    const mfaStatus = await fetchUser()

    if (mfaStatus === 'SETUP_REQUIRED') {
      return navigateTo('/account/required/mfa', { replace: true })
    }
  }

  // If there is no user, go to the login page if not already there
  if (!user.value && !to.path.startsWith('/login')) {
    return navigateTo('/login')
  }

  // If on the login page while we have a user, go back to the application
  if (to.name === 'login' && user.value) {
    return navigateTo('/')
  }
})
